import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCMS } from '../../context/CMSContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageCircle, FiPhone, FiMail, FiX } = FiIcons;

const QuickContact = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { content } = useCMS();
  const { company } = content;

  const contactOptions = [
    {
      icon: FiPhone,
      label: 'Appeler',
      value: company.phone,
      href: `tel:${company.phone}`,
      color: 'bg-green-500'
    },
    {
      icon: FiMessageCircle,
      label: 'WhatsApp',
      value: 'Chat WhatsApp',
      href: `https://wa.me/237675784656?text=Bonjour, je souhaite obtenir des informations sur vos services QHSE.`,
      color: 'bg-green-600'
    },
    {
      icon: FiMail,
      label: 'Email',
      value: company.email,
      href: `mailto:${company.email}`,
      color: 'bg-blue-500'
    }
  ];

  return (
    <>
      {/* Quick Contact Button */}
      <motion.div
        className="fixed bottom-6 right-6 z-50"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 2 }}
      >
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-pink-600 text-white p-4 rounded-full shadow-lg hover:bg-pink-700 transition-colors"
        >
          <SafeIcon icon={isOpen ? FiX : FiMessageCircle} className="w-6 h-6" />
        </button>
      </motion.div>

      {/* Contact Options */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            className="fixed bottom-24 right-6 z-40 bg-white rounded-lg shadow-xl border p-4 min-w-64"
          >
            <h3 className="font-semibold text-gray-900 mb-3">Contact Rapide</h3>
            <div className="space-y-2">
              {contactOptions.map((option, index) => (
                <motion.a
                  key={option.label}
                  href={option.href}
                  target={option.label === 'WhatsApp' ? '_blank' : undefined}
                  rel={option.label === 'WhatsApp' ? 'noopener noreferrer' : undefined}
                  className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
                  initial={{ x: 50, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <div className={`p-2 rounded-lg ${option.color}`}>
                    <SafeIcon icon={option.icon} className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{option.label}</p>
                    <p className="text-sm text-gray-600">{option.value}</p>
                  </div>
                </motion.a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default QuickContact;